import {APIENDPOINT} from '../constants';
var APIURL = window.bookingsUrl + APIENDPOINT;
export default {
  init() {

    var AUTH = window.AUTH;
    var globalData = {};
    var $datepicker = $('.rooms-datepicker');
    var date = new Date();
    var monthNames = [
      "Jan", "Feb", "Mar",
      "Apr", "May", "Jun", "Jul",
      "Aug", "Sep", "Oct",
      "Nov", "Dec"
    ];

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

    $datepicker.val(day + ' ' + monthNames[monthIndex] + ', ' + year);
    $datepicker.datepicker({
      dateFormat: 'd M, yy',
      minDate: new Date(),
      onSelect: function (dateText, inst) {
        reRenderRooms(new Date(inst.currentYear, inst.currentMonth, inst.currentDay));
      }
    });


    function get_rooms () {

      var roomsurl = APIURL + "rooms";
      var timeslotsurl = APIURL + "timeslots";


      var rooms = $.ajax({
        url: roomsurl,
        method: 'GET',
        beforeSend: function (req) {
          req.setRequestHeader('Authorization', AUTH);
        },
      });

      var timeslots = $.ajax({
        url: timeslotsurl,
        method: 'GET',
        beforeSend: function (req) {
          req.setRequestHeader('Authorization', AUTH);
        },
      });

      /*eslint-disable */
      Promise.all([timeslots, rooms]).then(function (response) {
        var rooms = response[1]._embedded.rooms;
        var $roomsContainer = $('.rooms-container');
        var data = {
          rooms: rooms,
          timeslots: response[0]._embedded.timeslots
        };
        setData(data);
        var today = new Date();
		var filterButtons=[];
		
		
		
        var promises = rooms.map(function (room) {
	      
	    filterButtons.push(room.capacity);
	    
// 		console.log("capacity: ", filterButtons);  
          var bookingsfrom = APIURL + "bookings?from=" + $.datepicker.formatDate('yy-mm-dd', today) + '&room=' + room.id + '&to=' + $.datepicker.formatDate('yy-mm-dd', today);
          return $.ajax({
            url: bookingsfrom,
            method: 'GET',
            beforeSend: function (req) {
              req.setRequestHeader('Authorization', AUTH);
            }
          }).then(function (roomResponse) {
            return [room, roomResponse];
          });
        });

		// setup room filter buttons


		filterButtons=removeDups(filterButtons);
		//console.log(filterButtons);
			filterButtons.forEach(function(size){
				document.getElementById("filterButtons").innerHTML+=`<div class="cursor-pointer md:w-auto w-24 inline-flex bg-secondary-light room-select-size mx-3 my-2 md:mx-0 md:mr-4 text-center items-center h-12 rounded-full" data-size="`+size+`">
		<div class="ml-4"><svg  xmlns="http://www.w3.org/2000/svg" width="34.291" height="27.098" viewBox="0 0 34.291 27.098">
			<g id="Group_1780" data-name="Group 1780" transform="translate(-373 -547)">
				<g id="Lager_6" data-name="Lager 6" transform="translate(392.574 551.328)">
					<path id="Path_2259" data-name="Path 2259" d="M1806.921,256.95c-1.059-5.3-6.8-5.826-7.317-7.02a2.132,2.132,0,0,1-.156-.832,6.668,6.668,0,0,0,3.259-6.031c0-3.6-2.339-6.5-5.223-6.5s-5.223,2.9-5.223,6.5a6.668,6.668,0,0,0,3.258,6.031,2.116,2.116,0,0,1-.156.832c-.169.388-.892.707-1.822,1.14a9.255,9.255,0,0,1,2.96,5.2l.006.03a5.151,5.151,0,0,1-.355,3.035h9.788C1807.332,259.338,1806.921,256.95,1806.921,256.95Z" transform="translate(-1792.26 -236.568)" fill="#00594f"/>
				</g>
				<g id="Lager_7" data-name="Lager 7" transform="translate(373 547)">
					<g id="Group_1779" data-name="Group 1779" transform="translate(0 0)">
						<path id="Path_2260" data-name="Path 2260" d="M1789.088,255.141c-1.261-6.3-8.088-6.934-8.709-8.354a2.537,2.537,0,0,1-.185-.99,7.935,7.935,0,0,0,3.878-7.178c0-4.28-2.783-7.734-6.216-7.735s-6.215,3.455-6.215,7.735a7.935,7.935,0,0,0,3.877,7.178,2.525,2.525,0,0,1-.186.99c-.621,1.419-7.447,2.049-8.708,8.354,0,0-.489,2.842,1.169,2.842h20.127C1789.577,257.983,1789.088,255.141,1789.088,255.141Z" transform="translate(-1766.556 -230.884)" fill="#00594f"/>
					</g>
				</g>
			</g>
		</svg>
		</div>

		<p class="ml-1 mr-6 dinpromedium text-secondary-dark">`+size+`</p>
	</div>`;
			});
		//

		    $('.room-select-size').on('click', function () {
		      var size = $(this).data('size');
		      var $rooms = $('.room');
		      if ($(this).hasClass('active')) {
		        $(this).removeClass('active');
		        $rooms.each(function () {
		          $(this).show();
		        })
		      } else {
		        $('.room-select-size').each(function () {
		          $(this).removeClass('active');
		        });
		        $(this).addClass('active');
		        $rooms.each(function () {
		          var $this = $(this);
		          if ($this.data('size') === size) {
		            $this.show();
		          } else {
		            $this.hide();
		          }
		        })
		      }
		
		    });



        Promise.all(promises).then(function (roomResponses) {
          roomResponses.forEach(function (roomResponse) {
              $roomsContainer.append(renderRoom(roomResponse));

          })
        });
      }).catch(function (error) {
        console.log("error", error);
      });


    };

    get_rooms();
    
    
    function removeDups(names) {
	  let unique = {};
	  names.forEach(function(i) {
	    if(!unique[i]) {
	      unique[i] = true;
	    }
	  });
	  return Object.keys(unique);
	}
    
    function renderRoom (data, date) {
      var room = data[0];
      var bookings = data[1]._embedded.bookings;
      var percentPos = 0;
      var hourPercent = (1 / (22 - 6));
      var dt = new Date();
      var takenslotsHtml = '';
      var currentDate;
      if (date) {
        if (date.getDate() === dt.getDate()) {
          var starttime = 6 * 60;
          if (dt.getHours() < 22 && dt.getHours() > 6) {
            var minutes = dt.getMinutes() + (dt.getHours() * 60);
            percentPos = (((minutes - starttime) / 60) * hourPercent) * 100;
          }
          takenslotsHtml = `
      <span class="absolute bg-black h-full" style="left:0%; width:${percentPos}%;"></span>
      `;
        }
        currentDate = $.datepicker.formatDate('yy-mm-dd', date);
      } else {
        var starttime = 6 * 60;
        if (dt.getHours() < 22 && dt.getHours() > 6) {
          var minutes = dt.getMinutes() + (dt.getHours() * 60);
          percentPos = (((minutes - starttime) / 60) * hourPercent) * 100;
        }
        var takenslotsHtml = `
      <span class="absolute bg-black h-full" style="left:0%; width:${percentPos}%;"></span>
      `;
        currentDate = $.datepicker.formatDate('yy-mm-dd', dt);
      }

      if (bookings) {
        for (var j = 0; j < bookings.length; j++) {
          var takenslot = bookings[j];
          var fromStrings = takenslot.from.split(/[^0-9]/);
          var toStrings = takenslot.to.split(/[^0-9]/);
          var from = new Date(fromStrings[0],fromStrings[1]-1,fromStrings[2],fromStrings[3],fromStrings[4],fromStrings[5] );
          var to = new Date(toStrings[0],toStrings[1]-1,toStrings[2],toStrings[3],toStrings[4],toStrings[5] );
          var hours = to.getHours() - from.getHours();
          var start = from.getHours();
          if (from.getMinutes() === 30) {
            start += 0.5;
          }
          if (to.getMinutes() > from.getMinutes()) {
            hours += 0.5;
          } else if (from.getMinutes() > to.getMinutes()) {
            hours -= 0.5;
          }
          
          takenslotsHtml += `
        <span class="absolute room-${room.id} bg-black h-full" style="left:${((start - 6) * hourPercent) * 100}%; width:${(hourPercent * hours) * 100}%;"></span>
        `;

        }
      }

      var roomBodyHtml = room.body.replace(/\<br \/>/g, ' \/\/ ');
      var roomsHtml =
      `
    <div class="w-full bg-white flex mb-6 room" data-size="${room.capacity}">
		<div class="md:block hidden w-64" style="background: url('${room.photo}') center center no-repeat; background-size: cover;">&nbsp;</div>
		<div class="w-full p-0 md:p-6 text-right flex flex-col">
		<div class="md:hidden flex mb-8 ">
		  <div class="w-1/3 h-full" style="background: url('${room.photo}') center center no-repeat; background-size: cover;">&nbsp;</div>
		  <div class="w-2/3 px-6 pt-6 room-content-mobile">
        <div class="flex flex-col">
          <div class="flex items-center">
            <h3>${room.title}</h3>
            <img src="${HOME_URL}/wp-content/themes/epicenter/images/people-icon-black.svg" class="self-start h-6 ml-auto" />
            <p class="text-xl ml-2">${room.capacity}</p>
          </div>
          <span class="h-border bg-black rounded-full w-full my-2">&nbsp;</span>
          ${roomBodyHtml}
          <div class="flex mt-2 items-center"><span class="bg-secondary-light rounded-full h-6 w-6">&nbsp;</span><p class="text-black ml-2 dinpromedium ">Available times</p></div>
		    </div>
		  </div>
		</div>
		<div class="hidden md:flex mb-12 items-center"><span class="bg-secondary-light rounded-full h-6 w-6">&nbsp;</span><p class="text-black ml-2 dinpromedium">Available times</p></div>
		<div class="md:mx-0 mx-6 relative">

		<p class="z-10 absolute text-secondary-dark dinpromedium" style="${percentPos === 0 ? 'display: none;' : ''} top: -1.5rem; left:${percentPos}%; transform: translateX(-50%);">CURRENT TIME</p>
		<span class="z-10 absolute w-px bg-secondary-dark h-full" style="${percentPos === 0 ? 'display: none;' : ''} left:${percentPos}%;"></span>
		<div class="rounded-full my-2 justify-center w-full overflow-x-hidden h-8 bg-secondary-light relative">
		${takenslotsHtml}
		</div>
		</div>
    <div class="md:mx-0 mx-6 md:w-full mt-2 md:mb-12 flex ">
        <p style="width:12.5%;" class="text-left text-black">06:00</p>
        <p style="width:12.5%;" class="md:visible invisible text-left text-black">08:00</p>
        <p style="width:12.5%;" class="md:visible invisible text-left text-black">10:00</p>
        <p style="width:12.5%;" class="text-left text-black">12:00</p>
        <p style="width:12.5%;" class="md:visible invisible text-left text-black">14:00</p>
        <p style="width:12.5%;" class="md:visible invisible text-left text-black">16:00</p>
        <p style="width:12.5%;" class="md:visible invisible text-left text-black">18:00</p>
        <p style="width:12.5%;" class="text-left text-black">20:00</p>
      </div>
			<!-- time slots might be removed -->
			<div class="flex mb-4 md:p-0 p-6">
			<div class="hidden md:flex flex-col w-full text-left room-content">
         <div class="flex items-center">
          <h3>${room.title}</h3>
          <img src="${HOME_URL}/wp-content/themes/epicenter/images/people-icon-black.svg" class="self-start h-6 ml-2" />
          <p class="text-xl ml-2">${room.capacity}</p>
        </div>
        <span class="h-border bg-black rounded-full w-4/5 my-4">&nbsp;</span>
		  ${roomBodyHtml}
			</div>
			<button class="ml-auto mt-auto w-96"><a href="${HOME_URL}/booking/${room.id}/?date=${currentDate}" class="px-10 uppercase py-4 no-underline text-lg bg-secondary-light text-secondary-dark rounded-full">${translations.book_this_room}</a></button>
			</div>
		</div>
	</div>
      `;
      return roomsHtml;
    }

    function setData (data) {
      globalData = data;
    }

    function getData () {
      return globalData;
    }

    function reRenderRooms (date) {

      var data = getData();
      var rooms = data.rooms;
      var $roomsContainer = $('.rooms-container');
      $roomsContainer.html('');
// 	  
	  var now = new Date();
	  
// 	  console.log(today, "ToDay");
      var promises = rooms.map(function (room) {
        var bookingsfrom = APIURL + "bookings?from=" + $.datepicker.formatDate('yy-mm-dd', date) + '&room=' + room.id + '&to=' + $.datepicker.formatDate('yy-mm-dd', date);

        return $.ajax({
          url: bookingsfrom,
          method: 'GET',
          beforeSend: function (req) {
            req.setRequestHeader('Authorization', AUTH);
          }
        }).then(function (roomResponse) {
          return [room, roomResponse];
        });
      });

      Promise.all(promises).then(function (roomResponses) {
        roomResponses.forEach(function (roomResponse) {
          $roomsContainer.append(renderRoom(roomResponse, date));
        })
      });
    }
  }
};
